import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauth-layout',
  templateUrl: './unauth-layout.component.html',
  styleUrls: ['./unauth-layout.component.scss']
})
export class UnauthLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/layouts/unauth-layout/unauth-layout.component.ts